"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5489],{

/***/ 72272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ createFetchBasedFormFetcher; },
/* harmony export */   "R": function() { return /* binding */ submitForm; }
/* harmony export */ });
/**
 * @param {RequestInit} [options]
 */
function createFetchBasedFormFetcher(options) {
    return (formData, endpoint) => fetch(endpoint, Object.assign({ body: formData.toMultipartFormData(), method: 'post', 
        // IMPORTANT: Sitecore forms relies on cookies for some state management, so credentials must be included.
        credentials: 'include' }, options))
        .then((res) => res.json())
        .then((res) => res);
}
/**
 * @param {JssFormData} formData
 * @param {string} endpoint
 * @param {FormSubmitOptions} [options]
 */
function submitForm(formData, endpoint, options) {
    options = options || {};
    if (!options.fetcher) {
        options.fetcher = createFetchBasedFormFetcher();
    }
    return options.fetcher(formData, endpoint);
}


/***/ }),

/***/ 18205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T5": function() { return /* binding */ ComponentPropsContext; },
/* harmony export */   "ho": function() { return /* binding */ ComponentPropsReactContext; }
/* harmony export */ });
/* unused harmony export useComponentProps */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Component props context which we are using in order to store data fetched on components level (getStaticProps/getServerSideProps)
 */
const ComponentPropsReactContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/**
 * Hook in order to get access to props related to specific component. Data comes from ComponentPropsContext.
 * @see ComponentPropsContext
 * @param {string | undefined} componentUid component uId
 * @returns {ComponentData | undefined} component props
 */
function useComponentProps(componentUid) {
    if (!componentUid) {
        return undefined;
    }
    const data = useContext(ComponentPropsReactContext);
    return data[componentUid];
}
const ComponentPropsContext = ({ children, value, }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentPropsReactContext.Provider, { value: value }, children));


/***/ }),

/***/ 94506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react/dist/esm/components/Link.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const Link = (_a) => {
    var { field, editable, children, showLinkTextWithChildrenPresent } = _a, otherProps = __rest(_a, ["field", "editable", "children", "showLinkTextWithChildrenPresent"]);
    const dynamicField = field;
    if (!field ||
        (!dynamicField.editableFirstPart &&
            !dynamicField.value &&
            !dynamicField.href)) {
        return null;
    }
    const resultTags = [];
    // EXPERIENCE EDITOR RENDERING
    if (editable && dynamicField.editableFirstPart) {
        const markup = dynamicField.editableFirstPart + dynamicField.editableLastPart;
        // in an ideal world, we'd pre-render React children here and inject them between editableFirstPart and editableLastPart.
        // However, we cannot combine arbitrary unparsed HTML (innerHTML) based components with actual vDOM components (the children)
        // because the innerHTML is not parsed - it'd make a discontinuous vDOM. So, we'll go for the next best compromise of rendering the link field and children separately
        // as siblings. Should be "good enough" for most cases - and write your own helper if it isn't. Or bring xEditor out of 2006.
        const htmlProps = Object.assign(Object.assign({ className: 'sc-link-wrapper', dangerouslySetInnerHTML: {
                __html: markup,
            } }, otherProps), { key: 'editable' });
        resultTags.push(react.createElement("span", Object.assign({}, htmlProps)));
        // don't render normal link tag when editing, if no children exist
        // this preserves normal-ish behavior if not using a link body (no hacks required)
        if (!children) {
            return resultTags[0];
        }
    }
    // handle link directly on field for forgetful devs
    const link = dynamicField.href
        ? field
        : dynamicField.value;
    if (!link) {
        return null;
    }
    const anchorAttrs = {
        href: link.querystring ? `${link.href}?${link.querystring}` : link.href,
        className: link.class,
        title: link.title,
        target: link.target,
    };
    if (anchorAttrs.target === '_blank' && !anchorAttrs.rel) {
        // information disclosure attack prevention keeps target blank site from getting ref to window.opener
        anchorAttrs.rel = 'noopener noreferrer';
    }
    const linkText = showLinkTextWithChildrenPresent || !children ? link.text || link.href : null;
    resultTags.push(react.createElement('a', Object.assign(Object.assign(Object.assign({}, anchorAttrs), otherProps), { key: 'link' }), linkText, children));
    return react.createElement(react.Fragment, null, resultTags);
};
const LinkPropTypes = {
    field: prop_types_default().oneOfType([
        prop_types_default().shape({
            href: (prop_types_default()).string,
        }),
        prop_types_default().shape({
            value: (prop_types_default()).object,
            editableFirstPart: (prop_types_default()).string,
            editableLastPart: (prop_types_default()).string,
        }),
    ]).isRequired,
    editable: (prop_types_default()).bool,
    children: (prop_types_default()).node,
    showLinkTextWithChildrenPresent: (prop_types_default()).bool,
};
Link.propTypes = LinkPropTypes;
Link.defaultProps = {
    editable: true,
};
Link.displayName = 'Link';

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-nextjs/dist/esm/components/Link.js
var Link_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const Link_Link = (props) => {
    const { field, editable, children, internalLinkMatcher = /^\//g, showLinkTextWithChildrenPresent } = props, htmlLinkProps = Link_rest(props, ["field", "editable", "children", "internalLinkMatcher", "showLinkTextWithChildrenPresent"]);
    const value = (field.href
        ? field
        : field.value);
    const { href, querystring } = value;
    const isEditing = editable && field.editable;
    if (href && !isEditing) {
        const text = showLinkTextWithChildrenPresent || !children ? value.text || value.href : null;
        // determine if a link is a route or not.
        if (internalLinkMatcher.test(href)) {
            return (react.createElement((link_default()), { href: { pathname: href, query: querystring }, key: "link", locale: false },
                react.createElement("a", Object.assign({ title: value.title, target: value.target, className: value.class }, htmlLinkProps),
                    text,
                    children)));
        }
    }
    // prevent passing internalLinkMatcher as it is an invalid DOM element prop
    const reactLinkProps = Object.assign({}, props);
    delete reactLinkProps.internalLinkMatcher;
    return react.createElement(Link, Object.assign({}, reactLinkProps));
};
Link_Link.defaultProps = {
    editable: true,
};
Link_Link.displayName = 'NextLink';
Link_Link.propTypes = Object.assign({ internalLinkMatcher: prop_types_default().instanceOf(RegExp) }, LinkPropTypes);


/***/ }),

/***/ 6195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ Placeholder_Placeholder; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react/dist/esm/components/MissingComponent.js


const MissingComponent = (props) => {
    const componentName = props.rendering && props.rendering.componentName
        ? props.rendering.componentName
        : 'Unnamed Component';
    console.log(`Component props for unimplemented '${componentName}' component`, props);
    return (react.createElement("div", { style: {
            background: 'darkorange',
            outline: '5px solid orange',
            padding: '10px',
            color: 'white',
            maxWidth: '500px',
        } },
        react.createElement("h2", null, componentName),
        react.createElement("p", null, "JSS component is missing React implementation. See the developer console for more information.")));
};
MissingComponent.propTypes = {
    rendering: prop_types_default().shape({
        componentName: (prop_types_default()).string,
    }),
};
MissingComponent.displayName = 'MissingComponent';

// EXTERNAL MODULE: ./node_modules/style-attr/lib/index.js
var lib = __webpack_require__(73469);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react/dist/esm/utils.js

// https://stackoverflow.com/a/10426674/9324
const convertKebabCasetoCamelCase = (str) => str.replace(/^.|-./g, (letter, index) => index === 0 ? letter.toLowerCase() : letter.substr(1).toUpperCase());
/**
 * https://facebook.github.io/react/docs/dom-elements.html
 * We are only concerned with style at the moment, which needs to be converted from string to object to satisfy React.
 * We don't need to convert any other attributes (that we know of), because the placeholder renders them "as-is" by using the special "is" React prop.
 * For whatever reason though, the "style" prop is still validated as needing to be an object when using the "is" prop, which is why we need to convert from string to object.
 * @param {string} [style] style
 * @returns {Array} converted attributes
 */
const convertStyleAttribute = (style = '') => {
    // styleParse converts a style attribute string into an object format
    const parsedStyle = (0,lib/* parse */.Qc)(style, { preserveNumbers: true });
    return Object.keys(parsedStyle).reduce((initialResult, styleKey) => {
        const result = initialResult;
        const convertedKey = convertKebabCasetoCamelCase(styleKey);
        result[convertedKey] = parsedStyle[styleKey];
        return result;
    }, {});
};
const convertAttributesToReactProps = (attributes) => {
    if (!attributes) {
        return [];
    }
    return Object.keys(attributes).reduce((initialResult, attrName) => {
        const result = initialResult;
        switch (attrName) {
            case 'class': {
                result.className = attributes.class;
                break;
            }
            case 'style': {
                result.style = convertStyleAttribute(attributes.style);
                break;
            }
            default: {
                result[attrName] = attributes[attrName];
                break;
            }
        }
        return result;
    }, {});
};
/**
 * "class" property will be transformed into or appended to "className" instead.
 * @param {string} otherAttrs all other props included on the image component
 * * @returns {void}
 */
const addClassName = (otherAttrs) => {
    if (otherAttrs.class) {
        // if any classes are defined properly already
        if (otherAttrs.className) {
            let className = otherAttrs.className;
            className += ` ${otherAttrs.class}`;
            otherAttrs.className = className;
        }
        else {
            otherAttrs.className = otherAttrs.class;
        }
        delete otherAttrs.class;
    }
};

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react/dist/esm/components/HiddenRendering.js

const styles = {
    height: '100px',
    backgroundImage: 'linear-gradient(45deg, #ffffff 25%, #dcdcdc 25%, #dcdcdc 50%, #ffffff 50%, #ffffff 75%, #dcdcdc 75%, #dcdcdc 100%)',
    backgroundSize: '3px 3px',
};
const HiddenRendering = () => react.createElement("div", { style: styles });
const HIDDEN_RENDERING_NAME = 'Hidden Rendering';

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react/dist/esm/components/PlaceholderCommon.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





/** [SXA] common marker by which we find container fo replacing **/
const PREFIX_PLACEHOLDER = 'container-{*}';
class PlaceholderCommon extends react.Component {
    constructor(props) {
        super(props);
        this.nodeRefs = [];
        this.state = {};
        this.addRef = this.addRef.bind(this);
        this.updateKeyAttributes = this.updateKeyAttributes.bind(this);
        this.createRawElement = this.createRawElement.bind(this);
    }
    static getPlaceholderDataFromRenderingData(rendering, name) {
        let result;
        /** [SXA] it needs for deleting dynamics placeholder when we set him number(props.name) of container.
        from backend side we get common name of placeholder is called 'container-{*}' where '{*}' marker for replacing **/
        if (rendering && rendering.placeholders && rendering.placeholders[PREFIX_PLACEHOLDER]) {
            rendering.placeholders[name] = rendering.placeholders[PREFIX_PLACEHOLDER];
            delete rendering.placeholders[PREFIX_PLACEHOLDER];
        }
        if (rendering && rendering.placeholders && Object.keys(rendering.placeholders).length > 0) {
            result = rendering.placeholders[name];
        }
        else {
            result = null;
        }
        if (!result) {
            console.warn(`Placeholder '${name}' was not found in the current rendering data`, JSON.stringify(rendering, null, 2));
            return [];
        }
        return result;
    }
    componentDidMount() {
        this.updateKeyAttributes();
    }
    componentDidUpdate() {
        this.updateKeyAttributes();
    }
    componentDidCatch(error) {
        this.setState({ error });
    }
    getSXAParams(rendering) {
        return (rendering.params.FieldNames && {
            styles: `${rendering.params.GridParameters || ''} ${rendering.params.Styles || ''}`,
        });
    }
    getComponentsForRenderingData(placeholderData) {
        const _a = this.props, { name, fields: placeholderFields, params: placeholderParams, missingComponentComponent, hiddenRenderingComponent } = _a, placeholderProps = __rest(_a, ["name", "fields", "params", "missingComponentComponent", "hiddenRenderingComponent"]);
        return placeholderData
            .map((rendering, index) => {
            const key = rendering.uid
                ? rendering.uid
                : `component-${index}`;
            const commonProps = { key };
            // if the element is not a 'component rendering', render it 'raw'
            if (!rendering.componentName &&
                rendering.name) {
                return this.createRawElement(rendering, commonProps);
            }
            const componentRendering = rendering;
            let component;
            if (componentRendering.componentName === HIDDEN_RENDERING_NAME) {
                component = hiddenRenderingComponent !== null && hiddenRenderingComponent !== void 0 ? hiddenRenderingComponent : HiddenRendering;
            }
            else {
                component = this.getComponentForRendering(componentRendering);
            }
            if (!component) {
                console.error(`Placeholder ${name} contains unknown component ${componentRendering.componentName}. Ensure that a React component exists for it, and that it is registered in your componentFactory.js.`);
                component = missingComponentComponent !== null && missingComponentComponent !== void 0 ? missingComponentComponent : MissingComponent;
            }
            const finalProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, commonProps), placeholderProps), ((placeholderFields || componentRendering.fields) && {
                fields: Object.assign(Object.assign({}, placeholderFields), componentRendering.fields),
            })), ((placeholderParams || componentRendering.params) && {
                params: Object.assign(Object.assign(Object.assign({}, placeholderParams), componentRendering.params), this.getSXAParams(componentRendering)),
            })), { rendering: componentRendering });
            return react.createElement(component, this.props.modifyComponentProps ? this.props.modifyComponentProps(finalProps) : finalProps);
        })
            .filter((element) => element); // remove nulls
    }
    getComponentForRendering(renderingDefinition) {
        var _a;
        const componentFactory = this.props.componentFactory;
        if (!componentFactory || typeof componentFactory !== 'function') {
            console.warn(`No componentFactory was available to service request for component ${renderingDefinition}`);
            return null;
        }
        // Render SXA Rendering Variant
        if ((_a = renderingDefinition.params) === null || _a === void 0 ? void 0 : _a.FieldNames) {
            return componentFactory(renderingDefinition.componentName, renderingDefinition.params.FieldNames);
        }
        return componentFactory(renderingDefinition.componentName);
    }
    addRef(nodeRef) {
        this.nodeRefs.push(nodeRef);
    }
    createRawElement(elem, baseProps) {
        if (!elem.name) {
            console.error('"elem.name" is undefined in "createRawElement". Something is likely wrong with your component data. Ensure that your components have a name.');
            return null;
        }
        const attributes = convertAttributesToReactProps(elem.attributes);
        const props = Object.assign(Object.assign(Object.assign({}, baseProps), attributes), { dangerouslySetInnerHTML: elem.contents ? { __html: elem.contents } : undefined });
        /* Since we can't set the "key" attribute via React, stash it
         * so we can set in the DOM after render.
         */
        if (!Array.isArray(attributes) && attributes && attributes.chrometype === 'placeholder') {
            props.phkey = elem.attributes.key; // props that get rendered as dom attribute names need to be lowercase, otherwise React complains.
            props.ref = this.addRef; // only need ref for placeholder containers, trying to add it to other components (e.g. stateless components) may result in a warning.
        }
        return react.createElement(elem.name, props);
    }
    updateKeyAttributes() {
        if (!this.nodeRefs) {
            return;
        }
        this.nodeRefs.forEach((ref) => {
            if (ref && ref.getAttribute) {
                // ref might be a wrapped component, so check for existence of getAttribute method
                const key = ref.getAttribute('phkey');
                if (key) {
                    // need to manually set the 'key' attribute after component mount because
                    // 'key' is a reserved attribute/prop in React. so it will never be rendered
                    // as an html attribute.
                    ref.setAttribute('key', key);
                }
            }
        });
    }
}
PlaceholderCommon.propTypes = {
    rendering: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).object,
    ]).isRequired,
    fields: prop_types_default().objectOf(prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).object,
    ]).isRequired),
    params: prop_types_default().objectOf((prop_types_default()).string.isRequired),
    missingComponentComponent: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).func,
    ]),
    hiddenRenderingComponent: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).func,
    ]),
    errorComponent: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).func,
    ]),
    modifyComponentProps: (prop_types_default()).func,
};

// EXTERNAL MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react/dist/esm/components/SitecoreContext.js
var SitecoreContext = __webpack_require__(21201);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react/dist/esm/enhancers/withComponentFactory.js



/**
 * @param {React.ComponentClass<T> | React.SFC<T>} Component
 */
function withComponentFactory(Component) {
    /**
     * @param {T} props - props to pass to the wrapped component
     * @returns {JSX.Element} - the rendered component
     */
    function WithComponentFactory(props) {
        const context = (0,react.useContext)(SitecoreContext/* ComponentFactoryReactContext */.R7);
        return react.createElement(Component, Object.assign({}, props, { componentFactory: props.componentFactory || context }));
    }
    WithComponentFactory.displayName = `withComponentFactory(${Component.displayName ||
        Component.name ||
        'Anonymous'})`;
    return WithComponentFactory;
}

// EXTERNAL MODULE: ./node_modules/@sitecore-jss/sitecore-jss/dist/cjs/utils/index.js
var utils = __webpack_require__(18996);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react/dist/esm/components/Placeholder.js




/**
 * @param {HtmlElementRendering | ComponentRendering} rendering
 */
function isRawRendering(rendering) {
    return (!rendering.componentName &&
        rendering.name !== undefined);
}
class PlaceholderComponent extends PlaceholderCommon {
    constructor(props) {
        super(props);
        this.isEmpty = false;
    }
    componentDidMount() {
        super.componentDidMount();
        if (this.isEmpty && utils.HorizonEditor.isActive()) {
            utils.HorizonEditor.resetChromes();
        }
    }
    /**
     * In case we need to render an empty placeholder, some part of the markup will be inserted by the EE,
     * so we need to separate the empty placeholder's markup and allow React reconciliation to be executed correctly
     * and retain sibling tags
     * @param {React.ReactNode | React.ReactElement[]} node react node
     * @returns react node
     */
    renderEmptyPlaceholder(node) {
        return react.createElement("div", { className: "sc-jss-empty-placeholder" }, node);
    }
    render() {
        const childProps = Object.assign({}, this.props);
        delete childProps.componentFactory;
        if (this.state.error) {
            if (childProps.errorComponent) {
                return react.createElement(childProps.errorComponent, { error: this.state.error });
            }
            return (react.createElement("div", { className: "sc-jss-placeholder-error" },
                "A rendering error occurred: ",
                this.state.error.message,
                "."));
        }
        const renderingData = childProps.rendering;
        const placeholderData = PlaceholderCommon.getPlaceholderDataFromRenderingData(renderingData, this.props.name);
        const components = this.getComponentsForRenderingData(placeholderData);
        this.isEmpty = placeholderData.every((rendering) => isRawRendering(rendering));
        if (this.props.renderEmpty && this.isEmpty) {
            const rendered = this.props.renderEmpty(components);
            return components.length ? this.renderEmptyPlaceholder(rendered) : rendered;
        }
        else if (components.length && this.isEmpty) {
            return this.renderEmptyPlaceholder(components);
        }
        else if (this.props.render) {
            return this.props.render(components, placeholderData, childProps);
        }
        else if (this.props.renderEach) {
            const renderEach = this.props.renderEach;
            return components.map((component, index) => {
                if (component && component.props && component.props.type === 'text/sitecore') {
                    return component;
                }
                return renderEach(component, index);
            });
        }
        else {
            return components;
        }
    }
}
PlaceholderComponent.propTypes = PlaceholderCommon.propTypes;
const Placeholder = withComponentFactory(PlaceholderComponent);

// EXTERNAL MODULE: ./node_modules/@sitecore-jss/sitecore-jss-nextjs/dist/esm/components/ComponentPropsContext.js
var ComponentPropsContext = __webpack_require__(18205);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-nextjs/dist/esm/components/Placeholder.js



const Placeholder_Placeholder = (props) => {
    const componentPropsContext = (0,react.useContext)(ComponentPropsContext/* ComponentPropsReactContext */.ho);
    return (react.createElement(Placeholder, Object.assign({}, props, { modifyComponentProps: (initialProps) => {
            if (!initialProps.rendering.uid)
                return initialProps;
            const data = componentPropsContext[initialProps.rendering.uid];
            return Object.assign(Object.assign({}, initialProps), data);
        } })));
};


/***/ }),

/***/ 16606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ RichText; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sitecore_jss_sitecore_jss_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5245);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const prefetched = {};
const RichText = (props) => {
    const { internalLinksSelector = 'a[href^="/"]' } = props, rest = __rest(props, ["internalLinksSelector"]);
    const hasText = props.field && props.field.value;
    const isEditing = props.editable && props.field && props.field.editable;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const richTextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        // NOT IN EXPERIENCE EDITOR
        if (hasText && !isEditing) {
            initializeLinks();
        }
    }, []);
    const routeHandler = (ev) => {
        if (!ev.target)
            return;
        ev.preventDefault();
        const pathname = ev.target.href;
        router.push(pathname, pathname, { locale: false });
    };
    const initializeLinks = () => {
        const node = richTextRef.current;
        // selects all links that start with '/'
        const internalLinks = node && node.querySelectorAll(internalLinksSelector);
        if (!internalLinks || !internalLinks.length)
            return;
        internalLinks.forEach((link) => {
            if (!prefetched[link.pathname]) {
                router.prefetch(link.pathname, undefined, { locale: false });
                prefetched[link.pathname] = true;
            }
            link.addEventListener('click', routeHandler, false);
        });
    };
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_sitecore_jss_sitecore_jss_react__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, Object.assign({ ref: richTextRef }, rest));
};
RichText.propTypes = Object.assign({ internalLinksSelector: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string) }, _sitecore_jss_sitecore_jss_react__WEBPACK_IMPORTED_MODULE_2__/* .RichTextPropTypes */ .e);
RichText.defaultProps = {
    tag: 'div',
    editable: true,
};
RichText.displayName = 'NextRichText';


/***/ }),

/***/ 33654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q4": function() { return /* binding */ handleEditorFastRefresh; }
/* harmony export */ });
/* unused harmony exports getPublicUrl, handleExperienceEditorFastRefresh, getJssEditingSecret */
/* harmony import */ var chalk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32589);
/* harmony import */ var chalk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(chalk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sitecore_jss_sitecore_jss_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18996);
/* harmony import */ var _sitecore_jss_sitecore_jss_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_sitecore_jss_sitecore_jss_utils__WEBPACK_IMPORTED_MODULE_1__);
/* provided dependency */ var process = __webpack_require__(83454);


/**
 * Get the publicUrl.
 * This is used primarily to enable compatibility with the Sitecore Experience Editor.
 * This is set to http://localhost:3000 by default.
 * VERCEL_URL is provided by Vercel in case if we are in Preview deployment (deployment based on the custom branch),
 * preview deployment has unique url, we don't know exact url.
 */
const getPublicUrl = () => {
    if (process.env.VERCEL_URL)
        return `https://${process.env.VERCEL_URL}`;
    let url = "https://c-main.takamulstg.com";
    if (url === undefined) {
        console.warn(`${chalk__WEBPACK_IMPORTED_MODULE_0___default().yellow.bold('Warning:')} An PUBLIC_URL environment variable is not defined. Falling back to http://localhost:3000.`);
        url = 'http://localhost:3000';
    }
    else {
        try {
            new URL(url);
        }
        catch (error) {
            throw new Error(`The PUBLIC_URL environment variable '${url}' is not a valid URL.`);
        }
    }
    // Ensure no trailing slash
    return url.toString().replace(/\/$/, '');
};
/**
 * Since Sitecore editors do not support Fast Refresh:
 * 1. Subscribe on events provided by webpack.
 * 2. Reset editor chromes when build is finished
 * @param {boolean} [forceReload] force page reload instead of reset chromes
 * @default forceReload false
 */
const handleEditorFastRefresh = (forceReload = false) => {
    if (true) {
        // Only run if development mode and editor is active
        return;
    }
    const eventSource = new window.EventSource(`${getPublicUrl()}/_next/webpack-hmr`);
    window.addEventListener('beforeunload', () => eventSource.close());
    eventSource.onopen = () => console.log('[Sitecore Editor Fast Refresh Listener] Online');
    eventSource.onmessage = (event) => {
        if (event.data.indexOf('{') === -1)
            return; // heartbeat
        const payload = JSON.parse(event.data);
        console.debug(`[Sitecore Editor Fast Refresh Listener] Saw event: ${JSON.stringify(payload)}`);
        if (payload.action !== 'built')
            return;
        if (forceReload)
            return window.location.reload();
        setTimeout(() => {
            console.log('[Sitecore Editor HMR Listener] Sitecore editor does not support Fast Refresh, reloading chromes...');
            (0,_sitecore_jss_sitecore_jss_utils__WEBPACK_IMPORTED_MODULE_1__.resetEditorChromes)();
        }, 500);
    };
};
/**
 * Since Sitecore editors do not support Fast Refresh:
 * 1. Subscribe on events provided by webpack.
 * 2. Reset editor chromes when build is finished
 * @deprecated Will be removed in a future release. Please use handleEditorFastRefresh instead.
 * @param {boolean} [forceReload] force page reload instead of reset chromes
 * @default forceReload false
 */
const handleExperienceEditorFastRefresh = (/* unused pure expression or super */ null && (handleEditorFastRefresh));
const getJssEditingSecret = () => {
    const secret = process.env.JSS_EDITING_SECRET;
    if (!secret || secret.length === 0) {
        throw new Error('The JSS_EDITING_SECRET environment variable is missing or invalid.');
    }
    return secret;
};


/***/ }),

/***/ 93417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ FieldTypes; }
/* harmony export */ });
var FieldTypes;
(function (FieldTypes) {
    FieldTypes["Section"] = "{447AA745-6D29-4B65-A5A3-8173AA8AF548}";
    FieldTypes["TextField"] = "{983BFA5F-C6B6-4AEE-A3BB-46B95D52E7DF}";
    FieldTypes["FileUpload"] = "{7E9A0903-A52C-4843-BBE1-5B26BD162BED}";
    FieldTypes["Button"] = "{7CE25CAB-EF3A-4F73-AB13-D33BDC1E4EE2}";
    FieldTypes["SingleLineText"] = "{4EE89EA7-CEFE-4C8E-8532-467EF64591FC}";
    FieldTypes["MultipleLineText"] = "{A296A1C1-0DA0-4493-A92E-B8191F43AEC6}";
    FieldTypes["DateField"] = "{38137D30-7B2A-47D5-BBD8-133252C01B28}";
    FieldTypes["Email"] = "{04C39CAC-8976-4910-BE0D-879ED3368429}";
    FieldTypes["NumberField"] = "{5B153FC0-FC3F-474F-8CB8-233FB1BEF292}";
    FieldTypes["Checkbox"] = "{4DA85E8A-3B48-4BC6-9565-8C1F5F36DD1B}";
    FieldTypes["Telephone"] = "{DF74F55B-47E6-4D1C-92F8-B0D46A7B2704}";
    FieldTypes["DropdownList"] = "{E0CFADEE-1AC0-471D-A820-2E70D1547B4B}";
    FieldTypes["CheckboxList"] = "{D86A361A-D4FF-46B2-9E97-A37FC5B1FE1A}";
    FieldTypes["ListBox"] = "{222A2121-D370-4C6F-80A3-03C930B718BF}";
    FieldTypes["RadioButtonList"] = "{EDBD38A8-1AE9-42EC-8CCD-F5B0E2998B4F}";
    FieldTypes["Password"] = "{668A1C37-9D6B-483B-B7C1-340C92D04BA4}";
})(FieldTypes || (FieldTypes = {}));


/***/ }),

/***/ 23317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ Form; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-forms/dist/esm/FormTracker.js
var EventIds;
(function (EventIds) {
    EventIds["FieldCompleted"] = "2ca692cb-bdb2-4c9d-a3b5-917b3656c46a";
    EventIds["FieldError"] = "ea27aca5-432f-424a-b000-26ba5f8ae60a";
})(EventIds || (EventIds = {}));
/**
 * @param {RequestInit} [options]
 */
function createFetchBasedTrackerFetcher(options) {
    return (formData, endpoint) => fetch(endpoint, Object.assign({ body: JSON.stringify(formData), method: 'post', 
        // IMPORTANT: Sitecore forms relies on cookies for some state management, so credentials must be included.
        credentials: 'include' }, options));
}
class FormTracker {
    constructor(options) {
        this._currentField = null;
        this._fetcher = options.fetcher || createFetchBasedTrackerFetcher();
        this._endpoint = options.endpoint;
    }
    /**
     * Should be called prior to pushing any events, and again whenever new form schema data is received
     * @param {string} formId
     * @param {string} formSessionId
     * @param {string} enableTracking
     */
    setFormData(formId, formSessionId, enableTracking) {
        this._formId = formId;
        this._formSessionId = formSessionId;
        this._enableTracking = enableTracking;
    }
    onFocusField(field, value) {
        if (!this._enableTracking || !field.model.isTrackingEnabled) {
            this._resetField();
            return;
        }
        this._startTrackingField(field, value);
    }
    onBlurField(field, value, validationErrors) {
        const trackableField = field;
        if (!this._enableTracking || !field.model.isTrackingEnabled) {
            this._resetField();
            return;
        }
        const blurredAtTick = new Date().getTime();
        let duration = trackableField.focusedAtTick
            ? Math.round((blurredAtTick - trackableField.focusedAtTick) / 1000)
            : 0;
        trackableField.focusedAtTick = undefined;
        const fieldChanged = this._currentField &&
            this._currentField.fieldIdField.value !== trackableField.fieldIdField.value;
        if (fieldChanged) {
            this._startTrackingField(field, value);
            duration = 0;
        }
        if (fieldChanged || this._isValueChanged(value)) {
            if (this._currentField) {
                this._currentField.originalValue = value;
            }
            const clientEvent = this._buildEvent(field, EventIds.FieldCompleted, duration);
            const validationEvents = [];
            if (validationErrors) {
                validationErrors.forEach(() => {
                    validationEvents.push(this._buildEvent(field, EventIds.FieldError, duration));
                });
            }
            this._trackEvents([...validationEvents, clientEvent]);
        }
    }
    _startTrackingField(field, value) {
        const trackableField = field;
        trackableField.focusedAtTick = new Date().getTime();
        trackableField.originalValue = value;
        this._currentField = trackableField;
    }
    _resetField() {
        this._currentField = null;
    }
    _isValueChanged(newValue) {
        if (!this._currentField || typeof this._currentField.originalValue === 'undefined') {
            return true;
        }
        const originalValue = this._currentField.originalValue;
        if (Array.isArray(newValue)) {
            if (!Array.isArray(originalValue)) {
                return true;
            }
            // array compare
            if (originalValue.length !== newValue.length) {
                return true;
            }
            for (let i = 0; i < originalValue.length; i += 1) {
                if (originalValue[i] !== newValue[i]) {
                    return true;
                }
            }
            return false;
        }
        // original value is array but value is not so cannot be equal
        if (Array.isArray(originalValue)) {
            return false;
        }
        // string compare
        return newValue !== this._currentField.originalValue;
    }
    _buildEvent(field, eventId, duration) {
        if (!this._formId || !this._formSessionId) {
            throw new Error('Event was pushed without form data being set.');
        }
        return {
            formId: this._formId,
            sessionId: this._formSessionId,
            eventId,
            fieldId: field.fieldIdField.value,
            duration,
            fieldName: field.model.name,
        };
    }
    _trackEvents(events) {
        return this._fetcher(events, this._endpoint);
    }
}

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-forms/dist/esm/FormField.js
/**
 * @param {object} object
 */
function instanceOfFormField(object) {
    return 'model' in object;
}
/**
 * @param {FormField} object
 */
function instanceOfValueFormField(object) {
    return 'indexField' in object;
}
/**
 * @param {FormField} object
 */
function instanceOfButtonFormField(object) {
    return 'buttonField' in object;
}
/**
 * @param {FormField} object
 */
function instanceOfFormFieldSection(object) {
    return 'fields' in object;
}

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-forms/dist/esm/ViewModel.js
/** The model for a given field's data elements */
/**
 * @param {ViewModel} object
 */
function instanceOfInputViewModel(object) {
    return 'value' in object;
}
/**
 * @param {ViewModel} object
 */
function instanceOfListViewModel(object) {
    return 'items' in object;
}

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-forms/dist/esm/getFieldValueFromModel.js

/** Retrieves the current value of a form field from the form model returned from the JSON API
 * @param {FormField} field
 * @returns {string | string[] | boolean} field value
 */
function getFieldValueFromModel(field) {
    if (instanceOfListViewModel(field.model)) {
        // field state from API view-model items (list fields with possible multi-select)
        // we map this into an array of selected values
        return field.model.items.filter((item) => item.selected).map((item) => item.value);
    }
    if (instanceOfInputViewModel(field.model)) {
        // field state from API view-model value (single valued fields)
        // false literal is a falsy value we want to keep (used in checkboxes)
        if (field.model.value === false) {
            return field.model.value;
        }
        // otherwise, we never want a null or undefined value so we default falsy to empty strings
        return field.model.value || '';
    }
    // the model cannot be null or undefined as in React a controlled field must be bound to a non-null value
    return '';
}

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-forms/dist/esm/JssFormData.js
/**
 * Stores the serialized state of a JSS form before it is POSTed back to the server.
 * Similar API to FormData but supports urlencoded forms (needed for Sitecore antiforgery support),
 * and supports append/get which not all browsers do as of this writing.
 */
class JssFormData {
    constructor() {
        this.data = new Array();
    }
    /**
     * Appends a new key/value to the form data. Value will be added to any existing value that may exist.
     * @param {string} key
     * @param {string | File} value
     */
    append(key, value) {
        this.data.push({ key, value });
    }
    /**
     * Sets a key/value, removing any existing value(s) set for that key.
     * @param {string} key
     * @param {string | File} value
     */
    set(key, value) {
        this.remove(key);
        this.append(key, value);
    }
    /**
     * Removes any values for a given key from the form data.
     * @param {string} key
     */
    remove(key) {
        this.data = this.data.filter((entry) => entry.key !== key);
    }
    /**
     * Merges form data from a client-side state store (i.e. the user-specified values), overwriting any existing values for the keys
     * @param {Object} values
     */
    mergeOverwritingExisting(values) {
        Object.keys(values).forEach((key) => {
            const value = values[key];
            // for multi-valued fields, like checkbox lists,
            // we can receive an array of selected values.
            // we want to _set_ the first one to override anything existing,
            // but _append_ anything after that to avoid overwriting our own values
            if (Array.isArray(value)) {
                if (value.length === 0) {
                    // if empty array, ensure any pre-filled values are cleared (i.e. user de-selected these)
                    this.remove(key);
                }
                else {
                    value.forEach((v, index) => {
                        if (index === 0) {
                            this.set(key, v);
                        }
                        else {
                            this.append(key, v);
                        }
                    });
                }
            }
            else {
                this.set(key, value.toString());
            }
        });
    }
    /**
     * Gets all key/values in the store. Duplicate keys with different values are possible.
     * @returns {Object} data
     */
    get() {
        return [...this.data];
    }
    /**
     * Converts the store into a FormData that can be POST-ed with fetch as multipart/form-data.
     * @returns {FormData} form data
     */
    toMultipartFormData() {
        const formData = new FormData();
        this.data.forEach((entry) => formData.append(entry.key, entry.value));
        return formData;
    }
    /**
     * Converts the store into a URL-encoded string suitable to POST as application/x-www-form-urlencoded.
     * @returns {string} url encoded form data
     */
    toUrlEncodedFormData() {
        return this.data
            .map((entry) => `${encodeURIComponent(entry.key)}=${encodeURIComponent(entry.value.toString())}`)
            .join('&')
            .replace(/%20/g, '+');
    }
}

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-forms/dist/esm/serializeForm.js




/**
 * Serializes a Sitecore Form data into a format ready to POST to the server.
 * @param {SitecoreForm} form The form schema data from the server
 * @param {SerializeFormOptions} [options]
 * @returns {JssFormData} form data
 */
function serializeForm(form, options) {
    if (!options) {
        options = {};
    }
    if (!options.fieldValueParser) {
        options.fieldValueParser = getFieldValueFromModel;
    }
    const result = new JssFormData();
    pushField(result, form.formSessionId);
    pushField(result, form.antiForgeryToken);
    pushField(result, form.formItemId);
    pushField(result, form.pageItemId);
    pushFields(result, form.fields, options);
    return result;
}
/**
 * @param {JssFormData} result
 * @param {Array<FormField>} fields
 * @param {SerializeFormOptions} options
 */
function pushFields(result, fields, options) {
    fields.forEach((field) => {
        if (instanceOfButtonFormField(field) &&
            (!options.submitButtonName || field.buttonField.name === options.submitButtonName)) {
            pushField(result, field.buttonField, field.model.title);
            pushField(result, field.navigationButtonsField);
            pushField(result, field.navigationStepField);
        }
        else if (instanceOfValueFormField(field)) {
            if (field.valueField.name.endsWith('.Files')) {
                const fileUploadField = field;
                if (!fileUploadField.originalValue && !fileUploadField.model.files) {
                    return;
                }
            }
            pushField(result, field.indexField);
            pushField(result, field.fieldIdField);
            // get stored value (i.e. if a multistep form)
            if (instanceOfInputViewModel(field.model) && options.fieldValueParser) {
                const fieldValue = options.fieldValueParser(field);
                if (Array.isArray(fieldValue)) {
                    fieldValue.forEach((value) => pushField(result, field.valueField, value));
                }
                else {
                    pushField(result, field.valueField, fieldValue.toString());
                }
            }
        }
        else if (instanceOfFormFieldSection(field)) {
            pushFields(result, field.fields, options);
        }
    });
}
/**
 * @param {JssFormData} result
 * @param {HtmlFormField} field
 * @param {string} [overrideValue]
 */
function pushField(result, field, overrideValue) {
    // the '' fallback prevents serializing 'null' as a string for empty field values ;)
    return pushFieldValue(result, field.name, overrideValue || field.value || '');
}
/**
 * @param {JssFormData} result
 * @param {string} fieldName
 * @param {string} fieldValue
 */
function pushFieldValue(result, fieldName, fieldValue) {
    if (!fieldName) {
        throw new Error('Field had no name');
    }
    result.append(fieldName, fieldValue);
}

// EXTERNAL MODULE: ./node_modules/@sitecore-jss/sitecore-jss-forms/dist/esm/submitForm.js
var submitForm = __webpack_require__(72272);
// EXTERNAL MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/default-field-factory.js + 20 modules
var default_field_factory = __webpack_require__(73392);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/default-error.js

const DefaultError = (props) => (react.createElement("div", { className: "form-errors" },
    props.formErrors.map((error, index) => (react.createElement("div", { className: "invalid", key: `formError-${index}` }, error))),
    props.fieldErrors.map((error, index) => (react.createElement("div", { className: "invalid", key: `fieldError-${index}` }, error.state.errors.map((message) => (react.createElement("div", { key: message }, message))))))));


;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/form.js




class Form extends react.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            // in a multistep form the server can reset the form schema
            // to display further steps; this state property overrides
            // the form passed in from props if present
            nextForm: null,
            submitButton: null,
        };
        this.createFieldComponent = this.createFieldComponent.bind(this);
        this.getCurrentFieldState = this.getCurrentFieldState.bind(this);
        this.collectCurrentFieldValues = this.collectCurrentFieldValues.bind(this);
        this._tracker = new FormTracker({
            endpoint: `${this.props.sitecoreApiHost}/api/jss/fieldtracking/register?sc_apikey=${this.props.sitecoreApiKey}`,
            fetcher: this.props.trackerFetcher,
        });
    }
    render() {
        const form = this.state.nextForm || this.props.form;
        if (!form) {
            return react.createElement("div", null, "No form data was provided. Need to set a datasource?");
        }
        if (!form.metadata) {
            return react.createElement("div", null, "Form data invalid. Forget to set the rendering contents resolver?");
        }
        const action = `${this.props.sitecoreApiHost}/api/jss/formbuilder?fxb.FormItemId=${form.metadata.itemId}&fxb.HtmlPrefix=${form.htmlPrefix}&sc_apikey=${this.props.sitecoreApiKey}&sc_itemid=${form.contextItemId}`;
        this._tracker.setFormData(form.formItemId.value, form.formSessionId.value, form.metadata.isTrackingEnabled);
        const fieldComponents = form.fields.map(this.createFieldComponent);
        const ErrorComponent = this.props.errorComponent || DefaultError;
        const fieldErrors = this.collectCurrentFieldValues().filter((field) => !field.state.isValid);
        return (react.createElement("form", { className: this.props.className, action: action, method: "POST", onSubmit: this.onSubmit.bind(this) },
            react.createElement(ErrorComponent, { form: form, formErrors: this.state.errors, fieldErrors: fieldErrors }),
            fieldComponents));
    }
    /**
     * Creates a field component to render a field based on the form schema data
     * @param {FormField} field
     * @returns {React.ReactNode} field component
     */
    createFieldComponent(field) {
        const props = Object.assign({ field, key: field.model.itemId, onChange: this.onFieldChange.bind(this), onButtonClick: this.onButtonClick.bind(this), fieldFactory: this.createFieldComponent, fieldValidationErrorsComponent: this.props.fieldValidationErrorsComponent, labelComponent: this.props.labelComponent, tracker: this._tracker }, this.getCurrentFieldState(field));
        const component = (this.props.fieldFactory || default_field_factory/* default */.Z).get(field, props);
        if (this.props.fieldWrapperComponent) {
            const Wrapper = this.props.fieldWrapperComponent;
            return react.createElement(Wrapper, Object.assign({}, props), component);
        }
        return component;
    }
    /**
     * Acquires the current form field state for a single field.
     * This state can come from two possible sources:
     * - The form schema/current data (default values, previously saved steps in multistep)
     * - This component's state (the mutated state of the field after user changes)
     * The field state includes both current value as well as current validity.
     * @param {FormField} field
     * @returns {Object | null} field state
     */
    getCurrentFieldState(field) {
        // non-valued fields, i.e. text, section, do not have a value or validity state
        if (!instanceOfValueFormField(field)) {
            return null;
        }
        const fieldName = field.valueField.name || null;
        if (!fieldName) {
            return null;
        }
        const fieldState = this.state[fieldName];
        // field has a value in react state i.e. due to user change
        if (fieldState) {
            const result = {
                isValid: fieldState.isValid,
                errors: fieldState.errors || [],
            };
            if (typeof fieldState.value !== 'undefined') {
                // field state from changed field value (in this.state)
                result.value = fieldState.value;
            }
            else {
                result.value = getFieldValueFromModel(field);
            }
            return result;
        }
        // default state from form API model
        return {
            isValid: true,
            errors: [],
            value: getFieldValueFromModel(field),
        };
    }
    /**
     * Handler triggered by child components that informs us which button triggered a submit.
     * This is important for multistep forms to disambiguate between back and next/submit buttons.
     * @param {string} buttonName
     */
    onButtonClick(buttonName) {
        this.setState({ submitButton: buttonName });
    }
    /**
     * Handler triggered by child components that updates a given field's current value
     * (which we then push back down to the child via prop)
     * @param {string} key Field's name attribute
     * @param {string | string[] | File[]} value New field value
     * @param {boolean} isValid Whether the field is valid or not
     * @param {string[]} errors Validation error message(s) if field is invalid
     */
    onFieldChange(key, value, isValid, errors) {
        this.setState({
            [key]: { value, isValid, errors },
        });
    }
    /**
     * Handler triggered when the form is submitted. May transition its state between
     * steps in a multistep form or handle a final submit.
     * @param {FormEvent} e
     */
    onSubmit(e) {
        e.preventDefault();
        const form = this.state.nextForm || this.props.form;
        const fieldValues = {};
        const currentFieldValues = this.collectCurrentFieldValues();
        currentFieldValues.forEach((field) => {
            if (typeof field.state.value !== 'undefined') {
                fieldValues[field.fieldName] = field.state.value;
            }
        });
        // NOTE: we're not pre-validating the submit on the client because
        // Sitecore won't be able to track validation errors in xConnect
        // serialize the form data that we got from the server
        // (hidden fields with constant values, unchanged default field values, etc)
        const formData = serializeForm(form, { submitButtonName: this.state.submitButton });
        // merge in user-updated field values
        formData.mergeOverwritingExisting(fieldValues);
        const submitUrl = e.target.action;
        if (!submitUrl) {
            throw new Error('Submit URL was not defined. Ensure the form has an action attribute.');
        }
        (0,submitForm/* submitForm */.R)(formData, submitUrl, { fetcher: this.props.formFetcher })
            .then((result) => {
            if (result.success && result.redirectUrl) {
                // Process redirect-on-success action.
                if (this.props.onRedirect) {
                    this.props.onRedirect(result.redirectUrl);
                }
                else {
                    window.location.href = result.redirectUrl;
                }
            }
            if (result.validationErrors) {
                const stateUpdate = {};
                Object.keys(result.validationErrors).forEach((fieldKey) => {
                    stateUpdate[fieldKey] = {
                        value: (this.state[fieldKey] || {}).value,
                        isValid: false,
                        errors: result.validationErrors[fieldKey],
                    };
                });
                this.setState(stateUpdate);
            }
            if (result.nextForm) {
                this.setState({ nextForm: result.nextForm });
            }
            if (result.success) {
                this.resetFieldsState();
            }
            if (result.errors && result.errors.length > 0) {
                throw result.errors;
            }
            this.setState({ errors: [] });
        })
            .catch((error) => {
            if (Array.isArray(error)) {
                this.setState({ errors: error });
            }
            else if (typeof error === 'string') {
                console.log('Form submit error', error);
                this.setState({ errors: [error] });
            }
            else {
                console.log('Form submit error', error);
                this.setState({ errors: [error.message] });
            }
        });
    }
    collectCurrentFieldValues() {
        return Object.keys(this.state)
            .filter((fieldName) => this.state[fieldName] && typeof this.state[fieldName].isValid !== 'undefined')
            .map((fieldName) => ({ fieldName: fieldName, state: this.state[fieldName] }));
    }
    /**
     * Removes the current fields' mutated state from this.state,
     * which prevents validation issues and mutable field state from following us
     * across steps in a multistep form.
     */
    resetFieldsState() {
        const keys = Object.keys(this.state).filter((key) => key !== 'nextForm' && key !== 'errors' && key !== 'submitButton');
        const stateReset = keys.reduce((acc, v) => (Object.assign(Object.assign({}, acc), { [v]: undefined })), {});
        this.setState(Object.assign(Object.assign({}, stateReset), { errors: [] }));
    }
}


/***/ }),

/***/ 73392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ createDefaultFieldFactory; },
  "Z": function() { return /* binding */ default_field_factory; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/section.js

const Section = ({ field, fieldFactory, }) => react.createElement("fieldset", { className: field.model.cssClass }, field.fields.map(fieldFactory));
/* harmony default export */ var section = (Section);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/text.js

const TextField = ({ field, }) => {
    const Tag = (field.model.htmlTag || 'p');
    return react.createElement(Tag, { className: field.model.cssClass }, field.model.text);
};
/* harmony default export */ var field_templates_text = (TextField);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/field-validation-errors.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const FieldValidationErrors = (props) => {
    if (props.fieldValidationErrorsComponent) {
        const CustomError = props.fieldValidationErrorsComponent;
        // strip the errors component from the custom component props
        // (prevents infinite loop rendering if someone reuses this component as a custom error component)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { fieldValidationErrorsComponent } = props, errorsComponentProps = __rest(props, ["fieldValidationErrorsComponent"]);
        return react.createElement(CustomError, Object.assign({}, errorsComponentProps));
    }
    const { errors } = props;
    if (!errors || errors.length === 0) {
        return null;
    }
    return (react.createElement("div", { className: "invalid" }, errors.map((error, index) => (react.createElement("p", { key: index }, error)))));
};


;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/label.js
var label_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const Label = (props) => {
    if (props.labelComponent) {
        const CustomLabel = props.labelComponent;
        // strip the label component from the custom component props
        // (prevents infinite loop rendering if someone reuses this component as a custom label component)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { labelComponent } = props, labelComponentProps = label_rest(props, ["labelComponent"]);
        return react.createElement(CustomLabel, Object.assign({}, labelComponentProps));
    }
    const { field, isValid, children } = props;
    let className = field.model.labelCssClass;
    if (!isValid) {
        className += ' invalid';
    }
    return (react.createElement("label", { htmlFor: field.valueField.id, className: className },
        children,
        field.model.title));
};


;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/ValidationDataModels.js
var ValidationDataModels;
(function (ValidationDataModels) {
    ValidationDataModels["FileSizeValidator"] = "{8F2B6077-FE63-4FB2-8740-EF3807BBDB84}";
    ValidationDataModels["FileTypeValidator"] = "{D81E056F-6C2E-4414-BD46-BA464AC05202}";
    ValidationDataModels["FileCountValidator"] = "{F42833A6-F364-4721-ABFC-337E0CC3FD75}";
})(ValidationDataModels || (ValidationDataModels = {}));

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/file-upload.js




class FileUpload extends react.Component {
    constructor() {
        super(...arguments);
        this.fileInputRef = (0,react.createRef)();
        this.SIZE_UNITS = {
            '1': 'Bytes',
            '1024': 'KB',
            '1048576': 'MB',
            '1073741824': 'GB',
        };
        this.onChangeField = (files, field, cb) => {
            const fileSizeValidator = this.getEnabledValidation(ValidationDataModels.FileSizeValidator);
            const fileCountValidator = this.getEnabledValidation(ValidationDataModels.FileCountValidator);
            const fileTypeValidator = this.getEnabledValidation(ValidationDataModels.FileTypeValidator);
            const list = [];
            const errorMessages = [];
            let valid = true;
            if (files) {
                Array(files.length)
                    .fill(null)
                    .forEach((_, idx) => {
                    const fileSize = files[idx].size / field.model.fileSizeUnit;
                    if (valid && fileSizeValidator && fileSize > field.model.maxFileSize) {
                        const msg = fileSizeValidator.message
                            .replace('{0}', field.model.maxFileSize.toString())
                            .replace('{1}', this.getFileSizeUnitName(field.model.fileSizeUnit));
                        errorMessages.push(msg);
                        valid = false;
                    }
                    list.push(files[idx]);
                });
            }
            if (fileTypeValidator) {
                list.some((file) => {
                    const ext = file.name.split('.').pop() || '';
                    if (field.model.allowedContentTypes.indexOf(ext) !== -1) {
                        return false;
                    }
                    const msg = fileTypeValidator.message.replace('{0}', field.model.allowedContentTypes);
                    errorMessages.push(msg);
                    return true;
                });
            }
            if (fileCountValidator && list.length > field.model.maxFileCount) {
                const msg = fileCountValidator.message
                    .replace('{0}', field.model.maxFileCount.toString())
                    .replace('{1}', field.model.title);
                errorMessages.push(msg);
                valid = false;
            }
            if (field.model.required && !list.length) {
                valid = false;
                errorMessages.push(`${field.model.title} is required`);
            }
            cb(field.valueField.name, list, valid, errorMessages);
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value && !this.props.value && this.fileInputRef.current) {
            this.fileInputRef.current.value = '';
        }
    }
    getEnabledValidation(itemId) {
        return this.props.field.model.validationDataModels.find((validation) => validation.itemId === itemId);
    }
    getFileSizeUnitName(value) {
        return this.SIZE_UNITS[value];
    }
    render() {
        const { field, value, onChange, errors, tracker } = this.props;
        const fileTypeValidator = this.getEnabledValidation(ValidationDataModels.FileTypeValidator);
        return (react.createElement(react.Fragment, null,
            react.createElement(Label, Object.assign({}, this.props)),
            react.createElement("input", { ref: this.fileInputRef, type: "file", accept: fileTypeValidator ? field.model.allowedContentTypes : undefined, multiple: field.model.isMultiple, className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, onChange: (e) => this.onChangeField(e.target.files, field, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
            react.createElement(FieldValidationErrors, Object.assign({}, this.props))));
    }
}
/* harmony default export */ var file_upload = (FileUpload);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/single-line-text.js



const SingleLineText = (props) => {
    const { field, value, onChange, errors, tracker } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("input", { type: "text", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: value, maxLength: field.model.maxLength, placeholder: field.model.placeholderText, onChange: (e) => handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} fieldValue
 * @param {FieldChangeCallback} callback
 */
function handleOnChange(field, fieldValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !fieldValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, fieldValue, valid, errorMessages);
}
/* harmony default export */ var single_line_text = (SingleLineText);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/button.js

// NOTE: onButtonClick is not a submit handler;
// it signals to the parent form which button invoked the submit action
// (which is important for multi-step forms where multiple submits can occur i.e. back/forward)
const Button = ({ field, onButtonClick }) => (react.createElement("button", { type: "submit", className: field.model.cssClass, value: field.model.title, name: field.buttonField.name, id: field.buttonField.id, onClick: () => onButtonClick(field.buttonField.name) }, field.model.title));
/* harmony default export */ var field_templates_button = (Button);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/checkbox.js



const Checkbox = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props),
            react.createElement("input", { type: "checkbox", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: "true", checked: value, onChange: (e) => checkbox_handleOnChange(field, e.target.checked, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) })),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {boolean} fieldValue
 * @param {FieldChangeCallback} callback
 */
function checkbox_handleOnChange(field, fieldValue, callback) {
    // (fieldName, fieldValue, isValid, validationErrors)
    callback(field.valueField.name, fieldValue, true, []);
}
/* harmony default export */ var field_templates_checkbox = (Checkbox);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/checkbox-list.js



const CheckboxList = (props) => {
    const { field, field: { model: { items }, }, value, onChange, errors, tracker, } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        items.map((item, index) => (react.createElement("label", { key: item.itemId },
            react.createElement("input", { type: "checkbox", className: field.model.cssClass, id: field.valueField.id + index, name: field.valueField.name, value: item.value, checked: value.some((v) => v === item.value), onChange: (e) => checkbox_list_handleOnChange(field, value, e.target.value, e.target.checked, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
            item.text))),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string[]} originalFieldValue
 * @param {string} changedElement
 * @param {boolean} checked
 * @param {FieldChangeCallback} callback
 */
function checkbox_list_handleOnChange(field, originalFieldValue, changedElement, checked, callback) {
    // we can have multiple selected values. So we need to push ALL the selected
    // values back up to the root form. This is done using an array, which the form
    // serializer knows how to expand into multiple values on post
    let value = originalFieldValue;
    if (checked) {
        value.push(changedElement);
    }
    else {
        value = value.filter((v) => v !== changedElement);
    }
    // (fieldName, fieldValue, isValid, validationErrors)
    callback(field.valueField.name, value, true, []);
}
/* harmony default export */ var checkbox_list = (CheckboxList);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/dropdown-list.js



const DropdownList = (props) => {
    const { field, field: { model: { items }, }, value, onChange, tracker, errors, } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("select", { className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: value[0], onChange: (e) => dropdown_list_handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) },
            field.model.showEmptyItem ? react.createElement("option", { label: " " }) : null,
            items.map((item) => (react.createElement("option", { key: item.itemId, value: item.value }, item.text)))),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} newValue
 * @param {FieldChangeCallback} callback
 */
function dropdown_list_handleOnChange(field, newValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !newValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, [newValue], valid, errorMessages);
}
/* harmony default export */ var dropdown_list = (DropdownList);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/date.js



const DateField = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("input", { type: "date", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: formatValue(value), min: formatValue(field.model.min), max: formatValue(field.model.max), onChange: (e) => date_handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {string} [value]
 */
function formatValue(value) {
    // dates are serialized from the API as full date/times (i.e. 2019-01-11T00:00:00)
    // but the date input expects only the date. Since the format is predictably long,
    // we can just take a substring.
    if (!value || value.length < 10) {
        return value;
    }
    return value.substring(0, 10);
}
/**
 * @param {ValueFormField} field
 * @param {string} fieldValue
 * @param {FieldChangeCallback} callback
 */
function date_handleOnChange(field, fieldValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !fieldValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, fieldValue, valid, errorMessages);
}
/* harmony default export */ var date = (DateField);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/email.js



const Email = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("input", { type: "email", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: value, maxLength: field.model.maxLength, placeholder: field.model.placeholderText, onChange: (e) => email_handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} fieldValue
 * @param {FieldChangeCallback} callback
 */
function email_handleOnChange(field, fieldValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !fieldValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, fieldValue, valid, errorMessages);
}
/* harmony default export */ var email = (Email);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/list-box.js



const ListBox = (props) => {
    const { field, field: { model: { items }, }, value, onChange, tracker, errors, } = props;
    let finalValue = value;
    // react does not like an array as a value unless multiple select is allowed
    // (even if the array is always length 1)
    if (!field.model.multipleSelection) {
        finalValue = value[0];
    }
    // note: the value for list field types is an array (of selected values)
    // dropdown is single-select so we use value[0] for its value
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("select", { className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: finalValue, size: field.model.rows, multiple: field.model.multipleSelection, onChange: (e) => list_box_handleOnChange(field, e.target.options, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }, items.map((item) => (react.createElement("option", { key: item.itemId, value: item.value }, item.text)))),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {HTMLOptionsCollection} options
 * @param {FieldChangeCallback} callback
 */
function list_box_handleOnChange(field, options, callback) {
    let valid = true;
    const errorMessages = [];
    const newValues = [];
    for (let i = 0; i < options.length; i += 1) {
        if (options[i].selected) {
            newValues.push(options[i].value);
        }
    }
    // custom client validation logic here
    if (field.model.required && newValues.length === 0) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, newValues, valid, errorMessages);
}
/* harmony default export */ var list_box = (ListBox);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/multiple-line-text.js



const MultipleLineText = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("textarea", { className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: value, rows: field.model.rows, maxLength: field.model.maxLength, placeholder: field.model.placeholderText, onChange: (e) => multiple_line_text_handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} fieldValue
 * @param {FieldChangeCallback} callback
 */
function multiple_line_text_handleOnChange(field, fieldValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !fieldValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, fieldValue, valid, errorMessages);
}
/* harmony default export */ var multiple_line_text = (MultipleLineText);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/number.js



const NumberField = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("input", { type: "number", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: value, step: field.model.step, min: field.model.min, max: field.model.max, onChange: (e) => number_handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} fieldValue
 * @param {FieldChangeCallback} callback
 */
function number_handleOnChange(field, fieldValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !fieldValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, fieldValue, valid, errorMessages);
}
/* harmony default export */ var number = (NumberField);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/password.js



const Password = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("input", { type: "password", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: value, maxLength: field.model.maxLength, placeholder: field.model.placeholderText, onChange: (e) => password_handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} fieldValue
 * @param {FieldChangeCallback} callback
 */
function password_handleOnChange(field, fieldValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !fieldValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, fieldValue, valid, errorMessages);
}
/* harmony default export */ var field_templates_password = (Password);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/radio-button-list.js



const RadioButtonList = (props) => {
    const { field, field: { model: { items }, }, value, onChange, tracker, errors, } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        items.map((item, index) => (react.createElement("label", { key: item.itemId },
            react.createElement("input", { type: "radio", className: field.model.cssClass, id: field.valueField.id + index, name: field.valueField.name, value: item.value, checked: value.some((v) => v === item.value), onChange: (e) => radio_button_list_handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
            item.text))),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} newValue
 * @param {FieldChangeCallback} callback
 */
function radio_button_list_handleOnChange(field, newValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !newValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, [newValue], valid, errorMessages);
}
/* harmony default export */ var radio_button_list = (RadioButtonList);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/components/field-templates/telephone.js



const Telephone = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (react.createElement(react.Fragment, null,
        react.createElement(Label, Object.assign({}, props)),
        react.createElement("input", { type: "tel", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: value, maxLength: field.model.maxLength, placeholder: field.model.placeholderText, onChange: (e) => telephone_handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
        react.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} fieldValue
 * @param {FieldChangeCallback} callback
 */
function telephone_handleOnChange(field, fieldValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !fieldValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, fieldValue, valid, errorMessages);
}
/* harmony default export */ var telephone = (Telephone);

// EXTERNAL MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/FieldTypes.js
var FieldTypes = __webpack_require__(93417);
;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/field-factory.js

/**
 * Maps field type IDs from Sitecore (/sitecore/system/Settings/Forms/Field Types)
 * into an implementing React component - this is very similar to the JSS componentFactory,
 * but it maps form element components instead of layout components
 */
class FieldFactory {
    constructor() {
        this._fieldMap = new Map();
        // eslint-disable-next-line react/display-name
        this._defaultComponent = (props) => (react.createElement("div", { key: props.model.fieldTypeItemId },
            props.model.name,
            ": No renderer for form element type ",
            props.model.fieldTypeItemId));
    }
    setComponentNotFoundComponent(component) {
        this._defaultComponent = component;
    }
    setComponent(type, component) {
        this._fieldMap.set(type, component);
    }
    get(field, props) {
        const Result = this._fieldMap.get(field.model.fieldTypeItemId);
        if (!Result) {
            const Default = this._defaultComponent;
            return react.createElement(Default, Object.assign({}, field));
        }
        return react.createElement(Result, Object.assign({}, props));
    }
}
/* harmony default export */ var field_factory = (FieldFactory);

;// CONCATENATED MODULE: ./node_modules/@sitecore-jss/sitecore-jss-react-forms/dist/esm/default-field-factory.js


















/**
 * Create default field factory
 */
function createDefaultFieldFactory() {
    const defaultFieldFactory = new field_factory();
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.Section */.U.Section, section);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.TextField */.U.TextField, field_templates_text);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.Button */.U.Button, field_templates_button);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.SingleLineText */.U.SingleLineText, single_line_text);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.MultipleLineText */.U.MultipleLineText, multiple_line_text);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.DateField */.U.DateField, date);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.Email */.U.Email, email);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.NumberField */.U.NumberField, number);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.Checkbox */.U.Checkbox, field_templates_checkbox);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.Telephone */.U.Telephone, telephone);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.FileUpload */.U.FileUpload, file_upload);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.DropdownList */.U.DropdownList, dropdown_list);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.CheckboxList */.U.CheckboxList, checkbox_list);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.ListBox */.U.ListBox, list_box);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.RadioButtonList */.U.RadioButtonList, radio_button_list);
    defaultFieldFactory.setComponent(FieldTypes/* FieldTypes.Password */.U.Password, field_templates_password);
    return defaultFieldFactory;
}
/* harmony default export */ var default_field_factory = (createDefaultFieldFactory());


/***/ }),

/***/ 53723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ DateField; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const DateField = (_a) => {
    var { field, tag, editable, render } = _a, otherProps = __rest(_a, ["field", "tag", "editable", "render"]);
    if (!field || (!field.editable && !field.value)) {
        return null;
    }
    let children;
    const htmlProps = Object.assign({}, otherProps);
    if (field.editable && editable) {
        htmlProps.dangerouslySetInnerHTML = {
            __html: field.editable,
        };
    }
    else if (render) {
        children = render(field.value ? new Date(field.value) : null);
    }
    else {
        children = field.value;
    }
    if (tag || (field.editable && editable)) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(tag || 'span', htmlProps, children);
    }
    else {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
    }
};
DateField.propTypes = {
    field: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
        value: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
        editable: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    }).isRequired,
    tag: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    editable: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
    render: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
};
DateField.defaultProps = {
    editable: true,
};
DateField.displayName = 'Date';


/***/ }),

/***/ 5245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ RichText; },
/* harmony export */   "e": function() { return /* binding */ RichTextPropTypes; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const RichText = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_a, ref) => {
    var { field, tag, editable } = _a, otherProps = __rest(_a, ["field", "tag", "editable"]);
    if (!field || (!field.editable && !field.value)) {
        return null;
    }
    const htmlProps = Object.assign({ dangerouslySetInnerHTML: {
            __html: field.editable && editable ? field.editable : field.value,
        }, ref }, otherProps);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(tag || 'div', htmlProps);
});
const RichTextPropTypes = {
    field: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
        value: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
        editable: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    }),
    tag: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    editable: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
};
RichText.propTypes = RichTextPropTypes;
RichText.defaultProps = {
    tag: 'div',
    editable: true,
};
RichText.displayName = 'RichText';


/***/ }),

/***/ 21201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qb": function() { return /* binding */ SitecoreContext; },
/* harmony export */   "R7": function() { return /* binding */ ComponentFactoryReactContext; },
/* harmony export */   "sy": function() { return /* binding */ SitecoreContextReactContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var deep_equal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10251);
/* harmony import */ var deep_equal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(deep_equal__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable @typescript-eslint/no-explicit-any */



const SitecoreContextReactContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
const ComponentFactoryReactContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
class SitecoreContext extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
    constructor(props) {
        super(props);
        /**
         * Update context state. Value can be @type {LayoutServiceData} which will be automatically transformed
         * or you can provide exact @type {SitecoreContextValue}
         * @param {SitecoreContextValue | LayoutServiceData} value New context value
         */
        this.setContext = (value) => {
            this.setState({
                context: value.sitecore
                    ? this.constructContext(value)
                    : Object.assign({}, value),
            });
        };
        const context = this.constructContext(props.layoutData);
        this.state = {
            context,
            setContext: this.setContext,
        };
    }
    constructContext(layoutData) {
        var _a;
        if (!layoutData) {
            return {
                pageEditing: false,
            };
        }
        return Object.assign({ route: layoutData.sitecore.route, itemId: (_a = layoutData.sitecore.route) === null || _a === void 0 ? void 0 : _a.itemId }, layoutData.sitecore.context);
    }
    componentDidUpdate(prevProps) {
        // In case if somebody will manage SitecoreContext state by passing fresh `layoutData` prop
        // instead of using `updateSitecoreContext`
        if (!deep_equal__WEBPACK_IMPORTED_MODULE_1___default()(prevProps.layoutData, this.props.layoutData)) {
            this.setContext(this.props.layoutData);
            return;
        }
    }
    render() {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentFactoryReactContext.Provider, { value: this.props.componentFactory },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(SitecoreContextReactContext.Provider, { value: this.state }, this.props.children)));
    }
}
SitecoreContext.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().any.isRequired),
    componentFactory: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
    layoutData: prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({
        sitecore: prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({
            context: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().any),
            route: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().any),
        }),
    }),
};
SitecoreContext.displayName = 'SitecoreContext';


/***/ }),

/***/ 72433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const Text = (_a) => {
    var { field, tag, editable, encode } = _a, otherProps = __rest(_a, ["field", "tag", "editable", "encode"]);
    if (!field || (!field.editable && (field.value === undefined || field.value === ''))) {
        return null;
    }
    // can't use editable value if we want to output unencoded
    if (!encode) {
        // eslint-disable-next-line no-param-reassign
        editable = false;
    }
    const isEditable = field.editable && editable;
    let output = isEditable
        ? field.editable || ''
        : field.value === undefined
            ? ''
            : field.value;
    // when string value isn't formatted, we should format line breaks
    if (!field.editable && typeof output === 'string') {
        const splitted = String(output).split('\n');
        if (splitted.length) {
            const formatted = [];
            splitted.forEach((str, i) => {
                const isLast = i === splitted.length - 1;
                formatted.push(str);
                if (!isLast) {
                    formatted.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", { key: i }));
                }
            });
            output = formatted;
        }
    }
    const setDangerously = isEditable || !encode;
    let children = null;
    const htmlProps = Object.assign({}, otherProps);
    if (setDangerously) {
        htmlProps.dangerouslySetInnerHTML = {
            __html: output,
        };
    }
    else {
        children = output;
    }
    if (tag || setDangerously) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(tag || 'span', htmlProps, children);
    }
    else {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
    }
};
Text.propTypes = {
    field: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
        value: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)]),
        editable: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    }),
    tag: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    editable: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
    encode: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
};
Text.defaultProps = {
    editable: true,
    encode: true,
};
Text.displayName = 'Text';


/***/ }),

/***/ 46240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ VisitorIdentification; }
/* harmony export */ });
/* harmony import */ var _enhancers_withSitecoreContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32862);

let emittedVI = false;
const VIComponent = () => {
    const { sitecoreContext } = (0,_enhancers_withSitecoreContext__WEBPACK_IMPORTED_MODULE_0__/* .useSitecoreContext */ .z)();
    if (emittedVI ||
        typeof document === 'undefined' ||
        !sitecoreContext.visitorIdentificationTimestamp) {
        // Don't emit VI script and meta tag if we've already done so,
        // aren't rendering client-side, or don't have a VI timestamp.
        return null;
    }
    emittedVI = true;
    const script = document.createElement('script');
    script.src = '/layouts/system/VisitorIdentification.js';
    script.type = 'text/javascript';
    const meta = document.createElement('meta');
    meta.name = 'VIcurrentDateTime';
    meta.content = sitecoreContext.visitorIdentificationTimestamp.toString();
    const head = document.querySelector('head');
    head && head.appendChild(script);
    head && head.appendChild(meta);
    return null;
};
VIComponent.displayName = 'VisitorIdentification';
const VisitorIdentification = VIComponent;


/***/ }),

/***/ 62099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ withDatasourceCheck; }
/* harmony export */ });
/* unused harmony export DefaultEditingError */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _withSitecoreContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32862);


const DefaultEditingError = () => (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sc-jss-editing-error", role: "alert" }, "Datasource is required. Please choose a content item for this component."));
/**
 * Checks whether a Sitecore datasource is present and renders appropriately depending on page mode (normal vs editing).
 * @param {WithDatasourceCheckOptions} [options]
 * @returns
 *  The wrapped component, if a datasource is present.
 *  A null component (in normal mode) or an error component (in editing mode), if a datasource is not present.
 */
function withDatasourceCheck(options) {
    return function withDatasourceCheckHoc(Component) {
        return function WithDatasourceCheck(props) {
            var _a, _b;
            const { sitecoreContext } = (0,_withSitecoreContext__WEBPACK_IMPORTED_MODULE_1__/* .useSitecoreContext */ .z)();
            const EditingError = (_a = options === null || options === void 0 ? void 0 : options.editingErrorComponent) !== null && _a !== void 0 ? _a : DefaultEditingError;
            return ((_b = props.rendering) === null || _b === void 0 ? void 0 : _b.dataSource) ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, props))) : sitecoreContext.pageEditing ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(EditingError, null)) : null;
        };
    };
}


/***/ }),

/***/ 32862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useSitecoreContext; }
/* harmony export */ });
/* unused harmony export withSitecoreContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_SitecoreContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21201);


/**
 * @param {WithSitecoreContextOptions} [options]
 */
function withSitecoreContext(options) {
    return function withSitecoreContextHoc(Component) {
        return function WithSitecoreContext(props) {
            const context = useContext(SitecoreContextReactContext);
            return (React.createElement(Component, Object.assign({}, props, { sitecoreContext: context.context, updateSitecoreContext: options && options.updatable && context.setContext })));
        };
    };
}
/**
 * This hook grants acсess to the current SiteCore page context
 * by default JSS includes the following properties in this context:
 * - pageEditing - Provided by Layout Service, a boolean indicating whether the route is being accessed via the Experience Editor.
 * - pageState - Like pageEditing, but a string: normal, preview or edit.
 * - site - Provided by Layout Service, an object containing the name of the current Sitecore site context.
 *
 * @see https://jss.sitecore.com/docs/techniques/extending-layout-service/layoutservice-extending-context
 *
 * @param {WithSitecoreContextOptions} [options] hook options
 *
 * @example
 * const EditMode = () => {
 *    const { sitecoreContext } = useSitecoreContext();
 *    return <span>Edit Mode is {sitecoreContext.pageEditing ? 'active' : 'inactive'}</span>
 * }
 *
 * @example
 * const EditMode = () => {
 *    const { sitecoreContext, updateSitecoreContext } = useSitecoreContext({ updatable: true });
 *    const onClick = () => updateSitecoreContext({ pageEditing: true });
 *    return <span onClick={onClick}>Edit Mode is {sitecoreContext.pageEditing ? 'active' : 'inactive'}</span>
 * }
 * @returns {Object} { sitecoreContext, updateSitecoreContext }
 */
function useSitecoreContext(options) {
    const reactContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_components_SitecoreContext__WEBPACK_IMPORTED_MODULE_1__/* .SitecoreContextReactContext */ .sy);
    const updatable = options === null || options === void 0 ? void 0 : options.updatable;
    return {
        sitecoreContext: reactContext.context,
        updateSitecoreContext: updatable ? reactContext.setContext : undefined,
    };
}


/***/ }),

/***/ 92682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resetExperienceEditorChromes = exports.isExperienceEditorActive = exports.handleEditorAnchors = exports.resetEditorChromes = exports.isEditorActive = exports.HorizonEditor = exports.ChromeRediscoveryGlobalFunctionName = exports.ExperienceEditor = void 0;
const is_server_1 = __importDefault(__webpack_require__(53641));
/**
 * Static utility class for Sitecore Experience Editor
 */
class ExperienceEditor {
    /**
     * Determines whether the current execution context is within a Experience Editor.
     * Experience Editor environment can be identified only in the browser
     * @returns true if executing within a Experience Editor
     */
    static isActive() {
        if (is_server_1.default()) {
            return false;
        }
        // eslint-disable-next-line
        const sc = window.Sitecore;
        return Boolean(sc && sc.PageModes && sc.PageModes.ChromeManager);
    }
    static resetChromes() {
        if (is_server_1.default()) {
            return;
        }
        window.Sitecore.PageModes.ChromeManager.resetChromes();
    }
}
exports.ExperienceEditor = ExperienceEditor;
/**
 * Copy of chrome rediscovery contract from Horizon (chrome-rediscovery.contract.ts)
 */
exports.ChromeRediscoveryGlobalFunctionName = {
    name: 'Sitecore.Horizon.ResetChromes',
};
/**
 * Static utility class for Sitecore Horizon Editor
 */
class HorizonEditor {
    /**
     * Determines whether the current execution context is within a Horizon Editor.
     * Horizon Editor environment can be identified only in the browser
     * @returns true if executing within a Horizon Editor
     */
    static isActive() {
        if (is_server_1.default()) {
            return false;
        }
        // Horizon will add "sc_horizon=editor" query string parameter for the editor and "sc_horizon=simulator" for the preview
        return window.location.search.indexOf('sc_horizon=editor') > -1;
    }
    static resetChromes() {
        if (is_server_1.default()) {
            return;
        }
        // Reset chromes in Horizon
        window[exports.ChromeRediscoveryGlobalFunctionName.name] &&
            window[exports.ChromeRediscoveryGlobalFunctionName.name]();
    }
}
exports.HorizonEditor = HorizonEditor;
/**
 * Determines whether the current execution context is within a Sitecore editor.
 * Sitecore Editor environment can be identified only in the browser
 * @returns true if executing within a Sitecore editor
 */
const isEditorActive = () => {
    return ExperienceEditor.isActive() || HorizonEditor.isActive();
};
exports.isEditorActive = isEditorActive;
/**
 * Resets Sitecore editor "chromes"
 */
const resetEditorChromes = () => {
    if (ExperienceEditor.isActive()) {
        ExperienceEditor.resetChromes();
    }
    else if (HorizonEditor.isActive()) {
        HorizonEditor.resetChromes();
    }
};
exports.resetEditorChromes = resetEditorChromes;
/**
 * @description in Experience Editor, anchor tags
 * with both onclick and href attributes will use the href, blocking the onclick from firing.
 * This function makes it so the anchor tags function as intended in the sample when using Experience Editor
 *
 * The Mutation Observer API is used to observe changes to the body, then select all elements with href="#" and an onclick,
 * and replaces the # value with javascript:void(0); which prevents the anchor tag from blocking the onclick event handler.
 * @see Mutation Observer API: https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver/MutationObserver
 */
const handleEditorAnchors = () => {
    // The sample gives the href attribute priority over the onclick attribute if both are present, so we must replace
    // the href attribute to avoid overriding the onclick in Experience Editor
    if (!window || !ExperienceEditor.isActive()) {
        return;
    }
    const targetNode = document.querySelector('body');
    const callback = (mutationList) => {
        mutationList.forEach((mutation) => {
            const btns = document.querySelectorAll('.scChromeDropDown > a[href="#"], .scChromeDropDown > a[href="#!"], a[onclick]');
            if (mutation.type === 'childList') {
                btns.forEach((link) => {
                    link.href = 'javascript:void(0);';
                });
            }
            return;
        });
    };
    const observer = new MutationObserver(callback);
    const observerOptions = {
        childList: true,
        subtree: true,
    };
    if (targetNode) {
        observer.observe(targetNode, observerOptions);
    }
};
exports.handleEditorAnchors = handleEditorAnchors;
/**
 * Determines whether the current execution context is within the Sitecore Experience Editor
 * @deprecated Will be removed in a future release. Please use isEditorActive instead.
 * @returns true if executing within the Sitecore Experience Editor
 */
exports.isExperienceEditorActive = exports.isEditorActive;
/**
 * Resets Sitecore Experience Editor "chromes"
 * @deprecated Will be removed in a future release. Please use resetEditorChromes instead.
 */
exports.resetExperienceEditorChromes = exports.resetEditorChromes;


/***/ }),

/***/ 18996:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleEditorAnchors = exports.resetExperienceEditorChromes = exports.isExperienceEditorActive = exports.resetEditorChromes = exports.isEditorActive = exports.HorizonEditor = exports.ExperienceEditor = exports.resolveUrl = exports.isServer = void 0;
var is_server_1 = __webpack_require__(53641);
Object.defineProperty(exports, "isServer", ({ enumerable: true, get: function () { return __importDefault(is_server_1).default; } }));
var resolve_url_1 = __webpack_require__(5650);
Object.defineProperty(exports, "resolveUrl", ({ enumerable: true, get: function () { return __importDefault(resolve_url_1).default; } }));
var editing_1 = __webpack_require__(92682);
Object.defineProperty(exports, "ExperienceEditor", ({ enumerable: true, get: function () { return editing_1.ExperienceEditor; } }));
Object.defineProperty(exports, "HorizonEditor", ({ enumerable: true, get: function () { return editing_1.HorizonEditor; } }));
Object.defineProperty(exports, "isEditorActive", ({ enumerable: true, get: function () { return editing_1.isEditorActive; } }));
Object.defineProperty(exports, "resetEditorChromes", ({ enumerable: true, get: function () { return editing_1.resetEditorChromes; } }));
Object.defineProperty(exports, "isExperienceEditorActive", ({ enumerable: true, get: function () { return editing_1.isExperienceEditorActive; } }));
Object.defineProperty(exports, "resetExperienceEditorChromes", ({ enumerable: true, get: function () { return editing_1.resetExperienceEditorChromes; } }));
Object.defineProperty(exports, "handleEditorAnchors", ({ enumerable: true, get: function () { return editing_1.handleEditorAnchors; } }));


/***/ }),

/***/ 53641:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Determines whether the current execution context is server-side
 * @returns true if executing server-side
 */
function isServer() {
    return !(typeof window !== 'undefined' && window.document);
}
exports["default"] = isServer;


/***/ }),

/***/ 5650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const is_server_1 = __importDefault(__webpack_require__(53641));
/**
 * note: encodeURIComponent is available via browser (window) or natively in node.js
 * if you use another js engine for server-side rendering you may not have native encodeURIComponent
 * and would then need to install a package for that functionality
 * @param {Object} params
 */
function getQueryString(params) {
    return Object.keys(params)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(String(params[k]))}`)
        .join('&');
}
/**
 * Resolves a base URL that may contain query string parameters and an additional set of query
 * string parameters into a unified string representation.
 * @param {string} urlBase the base URL that may contain query string parameters
 * @param {Object} params query string parameters
 * @returns a URL string
 * @throws {RangeError} if the provided url is an empty string
 */
function resolveUrl(urlBase, params = {}) {
    if (!urlBase) {
        throw new RangeError('url must be a non-empty string');
    }
    // This is a better way to work with URLs since it handles different user input
    // edge cases. This works in Node and all browser except IE11.
    // https://developer.mozilla.org/en-US/docs/Web/API/URL
    // TODO: Verify our browser support requirements.
    if (is_server_1.default()) {
        const url = new URL(urlBase);
        for (const key in params) {
            if ({}.hasOwnProperty.call(params, key)) {
                url.searchParams.append(key, String(params[key]));
            }
        }
        const result = url.toString();
        return result;
    }
    const qs = getQueryString(params);
    const result = urlBase.indexOf('?') !== -1 ? `${urlBase}&${qs}` : `${urlBase}?${qs}`;
    return result;
}
exports["default"] = resolveUrl;


/***/ })

}]);